"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertLinks = void 0;
const LinkEntity_1 = require("../model/LinkEntity");
const convertLinks = (entity) => {
    // Use the links we received from the API
    const rels = Object.keys(entity._links);
    // Reduce the rels into a single object
    return rels.reduce((acc, rel) => {
        acc[rel] = new LinkEntity_1.Link(entity._links[rel]);
        return acc;
    }, {});
};
exports.convertLinks = convertLinks;
//# sourceMappingURL=convertLinks.js.map